module.exports = __webpack_public_path__ + "static/img/1.9e893d60.png";